import { Component } from '@angular/core';
import { ModalCloseAction } from '../../store/modal.action';
import { Store } from '@ngrx/store';
import { AppState } from '../../store/modal.state';

@Component({
    selector: 'app-mobile-chrome-recommendation',
    templateUrl: './mobile-chrome-recommendation.component.html',
    styleUrls: ['./mobile-chrome-recommendation.component.scss']
})
export class MobileChromeRecommendationComponent {

    constructor(private store: Store<AppState>) {
    }

    continueAnyway() {
        this.store.dispatch(new ModalCloseAction());
    }
}
